import { fields } from ".";
import Button from "components/atoms/Button";
import { modalActions } from "redux/slices/modal";
import { reduxForm } from "redux-form";
import ReduxFormFields from "components/molecules/ReduxFormFields";
import { useDispatch } from "react-redux";

function UpdatePayRollForm({ handleSubmit }: any) {
  const dispatch = useDispatch();

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <h3>Update Employee Time</h3>
        <ReduxFormFields fields={fields} />
        <br />
        <Button
          variant="outlined"
          onClick={() => dispatch(modalActions.closeModal())}
          sx={{ marginRight: "10px" }}>
          Cancel
        </Button>
        <Button type="submit" variant="contained">
          Submit
        </Button>
      </form>
    </div>
  );
}

export default reduxForm({ form: "UpdatePayRollForm" })(UpdatePayRollForm);
